/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { UserInfo } from '@/types/login';
import { MerchantSettings } from '@/types/merchant';
import { ROUTE_KEY } from './constants/action-permission';

interface BusinessAssistantAccessInput {
  isAdmin?: boolean;
  merchantId?: number;
  isTestEnv: boolean;
}

export function getBusinessAssistantAccess({
  isAdmin,
  merchantId,
  isTestEnv,
}: BusinessAssistantAccessInput) {
  const canAccessBusinessAssistant = isTestEnv || merchantId === 2;

  return {
    canAccessBusinessAssistant,
    canAccessOperatingReport: Boolean(isAdmin && canAccessBusinessAssistant),
  };
}

export default function (initialState: {
  currentUser?: UserInfo;
  merchantConfig?: MerchantSettings;
}) {
  const { currentUser, merchantConfig } = initialState || {};
  const businessAssistantAccess = getBusinessAssistantAccess({
    isAdmin: currentUser?.isAdmin,
    merchantId: merchantConfig?.merchant_id,
    isTestEnv: IS_TEST_ENV,
  });

  return {
    // 是否显示经营分析菜单
    canAccessAnalysis: () => {
      const isShowStatistics = merchantConfig?.permission_config?.is_show_statistics;
      const hasPermission =
        currentUser?.isAdmin ||
        (currentUser?.role_data?.menu_codes || []).includes(ROUTE_KEY.Analysis);
      return isShowStatistics && hasPermission;
    },
    // 是否可以访问经营助手
    canAccessBusinessAssistant: () => businessAssistantAccess.canAccessBusinessAssistant,
    // 是否可以访问经营分析报告
    canAccessOperatingReport: () => businessAssistantAccess.canAccessOperatingReport,
    // 是否可以访问页面
    canAccessPage: (route: any) => {
      const hasPermission =
        currentUser?.isAdmin || (currentUser?.role_data?.menu_codes || []).includes(route.key);
      return hasPermission;
    },
  };
}
